import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BillingItemV26 } from 'src/app/models-v26/billingitem-v26';
import { ContractTreeNodeV26 } from 'src/app/models-v26/contract-v26';
import { ActionResponse } from 'src/app/models/action-response';
import * as fromAddServicesToContractsWizard from './reducer';
import { State } from './state';

export const selectAddServicesToContractsWizardState = createFeatureSelector<State>(
  fromAddServicesToContractsWizard.addServicesToContractsWizardFeatureKey,
);

export const selectServicesStep = createSelector(
  selectAddServicesToContractsWizardState,
  (state: State): BillingItemV26[] => state.servicesStep,
);

export const selectContractsStep = createSelector(
  selectAddServicesToContractsWizardState,
  (state: State): ContractTreeNodeV26[] => state.contractsStep,
);

export const selectAddServicesToContractsState = createSelector(
  selectAddServicesToContractsWizardState,
  (state: State): ActionResponse => state.response,
);

export const selectErrorMessage = createSelector(selectAddServicesToContractsWizardState, (state: State): string => state.errorMessage);
